import { useAppSelector } from 'app/hooks';

export const useOrg = () => {
  const orgId = useAppSelector((state) => state.app.orgId);
  const orgs = useAppSelector((state) => state.org.list);

  return orgs.find((item) => item.id === orgId);
};

export const useOrgId = () => {
  return useAppSelector((state) => state.app.orgId);
};
